import { Observable } from 'rxjs';
import { HttpRequest } from './http-request';
import { HttpResponse } from '@angular/common/http';
import { HttpRequestClient } from './http-request-client';
import { HttpError } from '..';

export abstract class HttpAuthenticationProvider {
  public abstract authenticate(request: HttpRequest): void;

  public abstract onAccessForbidden(
    http: HttpRequestClient,
    req: HttpRequest,
    res: Observable<HttpResponse<any>>
  ): Observable<HttpResponse<any>>;

  public abstract onUnathenticated(
    http: HttpRequestClient,
    req: HttpRequest,
    res: Observable<HttpResponse<any>>,
    error?: HttpError
  ): Observable<boolean>;
}
